import { Dialog, DialogTitle, DialogContent, DialogActions, Box } from '@mui/material';
import { isNil } from 'lodash';
import React from 'react';
import type { DialogProps } from '@mui/material';

export interface SimpleDialogProps extends Omit<DialogProps, 'content'> {
  title: string;
  content: React.ReactNode;
  actions?: React.ReactNode;
}

const SimpleDialog: React.FC<SimpleDialogProps> = ({
  title,
  content,
  actions,
  ...dialogProps
}) => (
  <Dialog {...dialogProps}>
    <DialogTitle>
      <Box
        overflow={'hidden'}
        sx={{ WebkitLineClamp: 2, display: '-webkit-box', WebkitBoxOrient: 'vertical' }}>
        {title}
      </Box>
    </DialogTitle>
    <DialogContent>{content}</DialogContent>
    {!isNil(actions) && <DialogActions>{actions}</DialogActions>}
  </Dialog>
);

export default SimpleDialog;
